import { Api } from "./config/request";

export const getOnlineStationsList = ()  => {
  return Api.getRequest("onlineStations/");
};

export const OnlineStations = { 
    getOnlineStationsList 
};
